/* Commission + currency helpers — vendor portal and admin side.
   Commission amounts are entered manually by the vendor (no auto-calc). */

export const CURRENCIES = ["INR", "USD", "GBP", "EUR", "AED", "AUD", "CAD", "SGD"];

export function parseNum(s) {
  const m = String(s == null ? "" : s).replace(/,/g, "").match(/-?[\d.]+/);
  return m ? parseFloat(m[0]) : null;
}

export function money(n) {
  if (n == null || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

// Commission lifecycle: none | pending | paid | received.
export function commStatus(r) {
  if (r.commissionStatus === "received") return "received";
  if (r.commissionStatus === "paid") return "paid";
  return r.status === "Signed Up" ? "pending" : "none";
}

// Live FX. open.er-api.com (free, no key, CORS-open) — base INR, so
// rates[X] = units of X per 1 INR.
export async function fetchRates() {
  try {
    const res = await fetch("https://open.er-api.com/v6/latest/INR");
    const j = await res.json();
    return j && j.rates ? j.rates : null;
  } catch (e) { return null; }
}

// Convert an amount in `currency` to INR.
export function toINR(amount, currency, rates) {
  const a = parseNum(amount);
  if (a == null) return null;
  if (!currency || currency === "INR") return Math.round(a);
  if (!rates || !rates[currency]) return null;
  return Math.round(a / rates[currency]);
}
